import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FriendlyDatePipe } from '../../../shared/pipes/friendly-date/friendly-date.pipe';
import { DateTimeService } from 'i2g-ng-utils';
import { FormAlignmentsEnum } from '../../form-master.enum';
import { CustomFormFieldComponent } from '../custom-form-field/custom-form-field.component';
import {
  ITrackingAction,
  ITrackingObject,
} from '../../../tracking/tracking.data';

export enum DatePickerHorizontalAlignmentsEnum {
  left = 'left',
  right = 'right',
}

export enum DatePickerVerticalAlignmentsEnum {
  top = 'top',
  bottom = 'bottom',
}

export interface IDatePickerFieldOptions {
  minDate?: string;
  maxDate?: string;
  allowEmptyDate?: boolean;
}

@Component({
  selector: 'app-date-picker-field',
  templateUrl: './date-picker-field.component.html',
  styleUrls: ['./date-picker-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatePickerFieldComponent),
      multi: true,
    },
  ],
})
export class DatePickerFieldComponent
  extends CustomFormFieldComponent
  implements ControlValueAccessor, OnInit, OnChanges {
  @Input() alignment: FormAlignmentsEnum;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() fieldId: string;
  @Input() e2eId: string;
  @Input() options: IDatePickerFieldOptions;
  @Input() formControl: AbstractControl;
  @Input() horizontalAlignment: DatePickerHorizontalAlignmentsEnum;
  @Input() verticalAlignment: DatePickerVerticalAlignmentsEnum;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingAction: ITrackingAction;

  @ViewChild('datePickerContainer', { static: true })
  datePickerContainer: ElementRef;

  hAlignment: DatePickerHorizontalAlignmentsEnum;
  vAlignment: DatePickerVerticalAlignmentsEnum;
  initialDate: string;
  minDate: string;
  allowEmptyDate: boolean;
  dateValue: string;
  maxDate: string;

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _friendlyDatePipe: FriendlyDatePipe,
    private _dateTimeService: DateTimeService,
    translateService: TranslateService
  ) {
    super(_changeDetectorRef, translateService);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.options && this.options) {
      this.minDate = this.options.minDate;
      this.maxDate = this.options.maxDate;
      this.allowEmptyDate = this.options.allowEmptyDate;
    }
  }

  ngOnInit() {
    this.fieldControl = this.formControl;
    this.hAlignment =
      this.horizontalAlignment || DatePickerHorizontalAlignmentsEnum.left;
    this.vAlignment =
      this.verticalAlignment || DatePickerVerticalAlignmentsEnum.bottom;

    super.ngOnInit();
  }

  writeValue(value: string) {
    const emptyDate = this.allowEmptyDate && !value;

    this.initialDate = emptyDate
      ? null
      : value || this._dateTimeService.getDateString();
    this.dateValue = emptyDate ? null : this._friendlyDatePipe.transform(value);

    this._changeDetectorRef.markForCheck();
  }
}
